import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormIndicationExam} from './FormIndicationExam'
import { Dialog } from 'primereact/dialog';

export const ModalIndicationExam = (props) => {

    const {
        toggle2, modal2,modalTitle, loading,method,
        // ? INDICATIONS PATIENT
        listIndication,CreateOrUpdateExamIndications,handleSelectValuesIndication,dataIndication,
        // ? INDICATIONs LABORATORY
        dataIndicationLab,listIndicationLab,handleSelectValuesIndication2
    }= props;


    return (
        <Dialog
            visible={modal2}
            onHide={toggle2}
            header={modalTitle}
            headerStyle={{
                backgroundColor: '#46afe5',
                color: 'white',
                fontWeight: 'bold'
            }}            
            modal
            closable
            dismissableMask={false} 
            blockScroll  
            className="large-dialog-exam"
        >

        {
            method === "list"
                ? <FormIndicationExam
                    button="Guardar"
                    {...{ toggle2, loading,listIndication,CreateOrUpdateExamIndications,
                        handleSelectValuesIndication,dataIndication,dataIndicationLab,listIndicationLab,handleSelectValuesIndication2}}
                />
                : (method === "update")
            
        }

        </Dialog>
      
       
    )
}
